import { Search } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function SearchHero({ query, setQuery, onSearch, loading }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) onSearch(query);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] sm:w-[600px] h-[400px] sm:h-[600px] bg-[#007AFF]/5 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 w-full max-w-2xl text-center">
        <h1 className="text-3xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white mb-2 sm:mb-3" style={{ fontFamily: "'Cabinet Grotesk', system-ui" }}>
          Image<span className="text-[#007AFF]">Scraper</span>
        </h1>
        <div className="mb-8 sm:mb-12" />

        <form data-testid={HOME.searchForm} onSubmit={handleSubmit} className="relative group">
          <div className="relative flex items-center">
            <Search className="absolute left-4 sm:left-5 w-4 sm:w-5 h-4 sm:h-5 text-white/30 group-focus-within:text-[#007AFF] transition-colors" />
            <input
              data-testid={HOME.searchInput}
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar imagens..."
              autoFocus
              className="w-full h-12 sm:h-16 pl-11 sm:pl-14 pr-24 sm:pr-32 bg-[#121214] border border-white/10 rounded-2xl text-base sm:text-lg text-white placeholder:text-white/25 outline-none focus:border-[#007AFF]/50 focus:ring-2 focus:ring-[#007AFF]/20 transition-all"
            />
            <button
              data-testid={HOME.searchButton}
              type="submit"
              disabled={loading || !query.trim()}
              className="absolute right-2 sm:right-3 h-8 sm:h-10 px-4 sm:px-6 bg-[#007AFF] hover:bg-[#007AFF]/90 disabled:opacity-40 disabled:cursor-not-allowed text-white text-xs sm:text-sm font-semibold rounded-xl transition-all cursor-pointer"
            >
              {loading ? "..." : "Buscar"}
            </button>
          </div>
        </form>

        <div className="mt-5 sm:mt-8 flex flex-wrap justify-center gap-2">
          {["Carol", "Paisagem Brasil", "Futebol", "Comida japonesa"].map((hint) => (
            <button
              key={hint}
              onClick={() => { setQuery(hint); onSearch(hint); }}
              className="px-3 sm:px-4 py-1.5 text-[11px] sm:text-xs font-mono text-white/40 border border-white/8 rounded-full hover:border-white/20 hover:text-white/60 transition-all cursor-pointer"
            >
              {hint}
            </button>
          ))}
        </div>
      </div>

      <div className="absolute bottom-6 sm:bottom-8 text-[10px] sm:text-xs font-mono text-white/15 tracking-widest uppercase">
        Scraper API v1.0
      </div>
    </div>
  );
}
